export default __webpack_public_path__ + "static/media/20210819182526.c2e2c74c.png";